export enum ProspectLoanType {
  CASH = 'Cash',
  MORTGAGE = 'Mortgage',
  REAL_ESTATE = 'RealEstate',
  INSURANCE = 'Insurance',
  SME = 'Sme',
}
